import { render, staticRenderFns } from "./BookingPriceBreakdownTables.vue?vue&type=template&id=178e074f&scoped=true&"
import script from "./BookingPriceBreakdownTables.vue?vue&type=script&lang=js&"
export * from "./BookingPriceBreakdownTables.vue?vue&type=script&lang=js&"
import style0 from "./BookingPriceBreakdownTables.vue?vue&type=style&index=0&id=178e074f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e074f",
  null
  
)

export default component.exports